import React from 'react';
import Header from "../header/Header";

const propTypes = {};

const defaultProps = {};

class Home extends React.Component {
	constructor(props) {
		super(props);

	}

	render() {
		return (
			<React.Fragment>
				<Header/>
				<section className="section-content--narrow">
					<h1 className="mt-spacing">Welcome to the State of Utah<br/>Offer Acceptance</h1>
					<p>To access recruitment offers you must click on the link provided in the recruitment email.</p>
					<p>If you have not received an email with a link to your offer please contact your hiring manager or recruiter.</p>
				</section>
			</React.Fragment>
		);
	}
}

Home.propTypes = propTypes;
Home.defaultProps = defaultProps;

export default Home;